import { RouteConfig } from '../types/routes';
import Landing from '../pages/landing';
import DataGridFuture from '../components/datagrid.future';
import DataGridAll from '../components/datagrid.all';
import HourlyRegister from '../components/datagrid.hourly';
import Reports from '../pages/reports';
import Dashboard from '../pages/dashboard';
import POS from '../pages/pos';
import DataGridPurchases from '../components/datagrid.purchases';
import Users from '../components/users';
import Vendors from '../components/vendors';
import Commissions from '../components/commissions';
import CommissionsApproval from '../components/CommissionsApproval';
import FeatureRequest from '../components/FeatureRequest';
import EventRequest from '../components/EventRequest';
import VideoPlayer from '../components/videoplayer';
import TopEvents from '../pages/topEvents';
import CycleManagement from '../components/CycleManagement';
import CloseCycles from '../components/CloseCycles';
import InvoiceReport from '../components/InvoiceReport';
import CloseCyclesReport from '../components/CloseCyclesReport';
import CommissionsClawback from '../components/CommissionsClawback';

// TicketEdge gets a vendor/consignor-scoped report instead of the standard
// Hourly Invoice Register, so exclude the register there.
const IS_TKTEDGE = process.env.REACT_APP_TENANT === 'TKTEdge';

export const mainRoutes: RouteConfig[] = [
  {
    label: 'Dashboard',
    element: Landing as any,
    path: '/*',
    children: [{ 
      index: true, 
      element: Dashboard,
      path: 'dashboard',
      label: 'Dashboard' 
    },
      { path: 'top-events', label: 'Top Events', element: TopEvents },
      { path: 'upcoming-events', label: 'Upcoming Events', element: DataGridFuture },
      { path: 'all-events', label: 'All Events', element: DataGridAll },
      { path: 'invoice-report', label: 'Invoice Report', element: InvoiceReport },
      { path: 'reports', label: 'Reports', element: Reports },
      { path: 'sell-inventory', label: 'Sell Inventory', element: POS },
      { path: 'purchases', label: 'Purchases', element: DataGridPurchases },
      { path: 'users', label: 'User Management', element: Users, isModal: true, requiresAdmin: true },
      { path: 'vendors', label: 'Vendor Management', element: Vendors, isModal: true, requiresVendors: true },
      { path: 'commissions', label: 'Commission Management', element: Commissions, isModal: true, requiresAdmin: true },
      { path: 'commissions-approval', label: 'Commission Approval', element: CommissionsApproval, isModal: true, requiresCommissions: true },
      { path: 'commissions-clawback', label: 'Commission Clawback', element: CommissionsClawback, isModal: true, requiresCommissionsClawback: true },
      { path: 'cycle-management', label: 'Cycle Management', element: CycleManagement, isModal: true, requiresCycleManagement: true },
      { path: 'close-cycles', label: 'Close Cycles', element: CloseCycles, isModal: true, requiresCycleClose: true },
      { path: 'closed-cycles-report', label: 'Closed Cycles Report', element: CloseCyclesReport, isModal: true, requiresCycleCloseReport: true },
      { path: 'hourly-report', label: 'Hourly Report', element: HourlyRegister, isModal: true, requiresAdmin: false },
      { path: 'feature-request', label: 'Feature Request', element: FeatureRequest, isModal: true, requiresAdmin: false },
      { path: 'event-request', label: 'Event Request', element: EventRequest, isModal: true, requiresAdmin: false },
      { path: 'training', label: 'Training Materials', element: VideoPlayer, isModal: true, requiresAdmin: false },
    ],
    requiresAuth: true,
  },
];
